// extracted by mini-css-extract-plugin
export var container = "_sv-0";
export var dotAnimation = "_sv-2";
export var dotsLoading = "_sv-1";